module.exports = __webpack_public_path__ + "img/LogoLMRSLR.903edf78.png";